export default __webpack_public_path__ + "static/media/308-Series-Heated-CO2-Regulators.500788de.jpg";